import { Module } from 'wrapper6'
import cssVars from 'css-vars-ponyfill'

export default class CssVars extends Module {
  ready (app) {
    cssVars()
  }
}
